// Backward-compatible types: legacy field `url_suffix`, new standardized field `apiPath`.
export type RawAccessItem = { url_suffix?: string; apiPath?: string; name: string };
export type AccessItem = { apiPath: string; name: string };

function toAccessItem(raw: RawAccessItem): AccessItem | null {
  const apiPath = raw.apiPath ?? raw.url_suffix;
  if (!apiPath) return null;
  return { apiPath, name: raw.name };
}

export function parseItems(data: unknown): AccessItem[] | null {
  let list: RawAccessItem[] | null = null;
  if (Array.isArray(data)) list = data as RawAccessItem[];
  else if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      if (Array.isArray(parsed)) list = parsed as RawAccessItem[];
    } catch {
      // ignore
    }
  }
  if (!list) return null;
  const normalized = list.map(toAccessItem).filter((x): x is AccessItem => !!x);
  return normalized;
}